var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded),
      expression: "loaded"
    }],
    staticClass: "order-detail order-confirm"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-title"
  }, [_vm._v("订单编号 \n\t\t"), _c('span', [_vm._v(_vm._s(_vm.order.order_no))])]), _vm._v(" "), _c('div', {
    staticClass: "info-card"
  }, [_c('div', {
    staticClass: "subtitle-info"
  }, [_vm._v("套餐信息")]), _vm._v(" "), _c('ul', {
    staticClass: "info-cont"
  }, [_c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("套餐名称")]), _c('span', [_vm._v(_vm._s(_vm.order.product_pkg_title))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("应付金额")]), _c('span', [_vm._v(_vm._s(_vm.order.rel_pay_price) + "元")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("服务时间")]), _c('span', [_vm._v(_vm._s(_vm.order.service_period) + " " + _vm._s(_vm.order.granularity == 2 ? '天' : '个月'))])])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-info top-dashed-line"
  }, [_vm._v("购买人信息")]), _vm._v(" "), _c('ul', {
    staticClass: "info-cont"
  }, [_c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.customer_name),
      expression: "order.customer_name"
    }],
    staticClass: "text-left",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.order.customer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order.customer_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.customer_mobile),
      expression: "order.customer_mobile"
    }],
    staticClass: "text-left",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.order.customer_mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.order.customer_mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.confiming) ? _c('li', {
    staticClass: "warning"
  }, [_vm._v("请确认手机号码，以顺利进行问卷和签订合同")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "section-title",
    staticStyle: {
      "margin-top": "6px"
    },
    on: {
      "click": function($event) {
        _vm.couponListVisibel = true
      }
    }
  }, [_c('div', {
    staticClass: "subtitle-info"
  }, [_vm._v("优惠券  \n\t\t\t"), (_vm.couponIndex == null) ? _c('span', {
    staticClass: "no-coupon"
  }, [_vm._v(_vm._s(_vm.couponMsg))]) : _c('span', {
    staticClass: "amount"
  }, [_vm._v("- ¥" + _vm._s(_vm.discount))]), _vm._v(" "), _c('b', [_vm._v(" >")])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('mt-button', {
    attrs: {
      "type": "primary"
    },
    domProps: {
      "textContent": _vm._s(_vm.btnText)
    },
    on: {
      "click": _vm.checkCoupon
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-50"
  }, [_vm._v("温馨提示: 如有疑问请联系您的专属服务助理")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.couponListVisibel),
      expression: "couponListVisibel"
    }],
    staticClass: "coupon-shadow"
  }, [_c('div', {
    staticClass: "coupon-box"
  }, [_c('div', {
    staticClass: "coupon-title"
  }, [_vm._v("优惠券选择 "), _c('span', {
    staticClass: "coupon-close",
    on: {
      "click": function($event) {
        _vm.couponListVisibel = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/iconClose.png",
      "alt": ""
    }
  })])]), _vm._v(" "), (_vm.couponList.length) ? _c('div', {
    staticClass: "coupon-list"
  }, _vm._l((_vm.couponList), function(coupon, i) {
    return _c('div', {
      key: coupon.code,
      staticClass: "coupon-card"
    }, [_c('div', {
      staticClass: "ticket"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (coupon.type == 10),
        expression: "coupon.type == 10"
      }],
      staticClass: "money-off"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/Coupon_Discount_Left.png",
        "alt": ""
      }
    }), _vm._v(" "), (coupon.amount <= 10000) ? _c('div', {
      staticClass: "money"
    }, [_vm._v(_vm._s(coupon.amount)), _c('span', [_vm._v("元")])]) : (coupon.amount > 10000) ? _c('div', {
      staticClass: "money"
    }, [_vm._v(_vm._s(coupon.amount / 10000)), _c('span', [_vm._v("万")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (coupon.type == 20),
        expression: "coupon.type == 20"
      }],
      staticClass: "money-off"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/Coupon_Full_Left.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "full-money"
    }, [_c('div', {
      staticClass: "full-title"
    }, [_vm._v("满减券")]), _vm._v(" "), _c('div', {
      staticClass: "full-des"
    }, [_vm._v("每满" + _vm._s(coupon.type_value) + "减" + _vm._s(coupon.amount))])])]), _vm._v(" "), _c('div', {
      staticClass: "ticket-content"
    }, [_c('div', {
      staticClass: "ticket-title"
    }, [_vm._v(_vm._s(coupon.title))]), _vm._v(" "), _c('div', {
      staticClass: "ticket-date"
    }, [_vm._v(_vm._s(_vm.formatData(coupon.start_time)) + "-" + _vm._s(_vm.formatData(coupon.end_time)))]), _vm._v(" "), (coupon.expire_status === 15) ? _c('img', {
      staticClass: "ticket-expired",
      attrs: {
        "src": "/static/img/Subscript_FastExpired.png",
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ticket-radio",
      on: {
        "click": function($event) {
          _vm.selectCoupon(i)
        }
      }
    }, [(_vm.couponIndex == i) ? _c('img', {
      attrs: {
        "src": "/static/img/Select.png",
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/img/Editing_Reveal.png",
        "alt": ""
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(coupon.range_description))])])
  })) : _c('div', {
    staticClass: "no-coupon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/Coupon.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("暂无可用优惠券，去别处逛逛吧")])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-header"
  }, [_c('p', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("如下信息将用于签订合同、开通服务，请确认是否正确.")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_vm._v("手机号码"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-43d6aba0","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/customer/OrderConfirm.vue
// module id = 239
// module chunks = 0